export default {
      id: "notification-usage",
      viewBox: "0 0 78 57",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#notification",
      toString: function () {
        return this.url;
      }
    }